import { CurrencyEnum } from '../../../enums';
import { FxOrder, FxOrderSideType } from '../../../models/reporting/types';

export const isSellEUR = (
  fxOrder: FxOrder,
): boolean => fxOrder.side === FxOrderSideType.Sell && fxOrder.soldAmountCurr === CurrencyEnum.EUR;

export const isBuyEUR = (
  fxOrder: FxOrder,
): boolean => fxOrder.side === FxOrderSideType.Buy && fxOrder.boughtAmountCurr === CurrencyEnum.EUR;
